import { v4 as uuidv4 } from 'uuid';

import { ErrorUtils } from './util.errors';
import { LandingType } from './utils.landing';
import { ASSIGNED_OFFER_CODES, COBRANDING_OFFER_CODES, DIGITAL_RETAILING_OFFER_CODES, UNASSIGNED_OFFER_CODES } from './utils.offer';

export const getMetadataForOfferExperience = (offerCode, dealerId, dealerGroupId, cobrandingGroupId) => {
  offerCode = offerCode && offerCode != 'null' ? offerCode : getOfferCode(dealerId, dealerGroupId, cobrandingGroupId);
  const landingType = getLandingType(offerCode);

  return {
    offerCode,
    landingType,
  };
};

const getOfferCode = (dealerId, dealerGroupId, cobrandingGroupId) => {
  if (cobrandingGroupId) {
    if (dealerGroupId) {
      return COBRANDING_OFFER_CODES.WC;
    }
    return COBRANDING_OFFER_CODES.OC;
  }

  if (dealerId) {
    return ASSIGNED_OFFER_CODES.W;
  }

  return UNASSIGNED_OFFER_CODES.N;
};

const getLandingType = (offerCode) => {
  if (Object.values(COBRANDING_OFFER_CODES).includes(offerCode)) {
    return LandingType.OEM;
  }

  if (Object.values(DIGITAL_RETAILING_OFFER_CODES).includes(offerCode)) {
    return LandingType.DigitalRetail;
  }

  if (Object.values(ASSIGNED_OFFER_CODES).includes(offerCode)) {
    return LandingType.Assigned;
  }

  return LandingType.Unassigned;
};

const ERROR_TEXTS_FOR_TYPE = {
  unsupportedUsageErrors: 'unsupported-usage',
  exceedOffersPerVIN: 'exceed-offers-vin',
  exceedOffersPerPhoneOrEmail: 'exceed-offers-phone-email',
  offerAlreadyProcessedErrors: 'offer-already-processed-generic',
};

export const getTaggingEvent = (error) => {
  const errorType = ErrorUtils.getErrorType(error);
  const errorText = ERROR_TEXTS_FOR_TYPE[errorType];
  return errorText ? `cta::go-error::${errorText}` : '';
};

export const getRandomGuid = () => {
  return uuidv4();
};
